import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["btnActive", "btnAll", "campaign", "hiddenIndicator", "hiddenCount"]

  connect() {
    // In some views the filter bar is not rendered; don't crash Stimulus.
    if (!this.hasBtnActiveTarget || !this.hasBtnAllTarget || !this.hasHiddenIndicatorTarget || !this.hasHiddenCountTarget) return

    // Default: show active campaigns (open/paused)
    this.applyFilter("active")
  }

  showActive() { this.applyFilter("active") }
  showAll()    { this.applyFilter("other") }

  applyFilter(filter) {
    this.currentFilter = filter

    if (this.hasBtnActiveTarget && this.hasBtnAllTarget) {
      if (filter === "active") {
        this.btnActiveTarget.classList.add("is-active")
        this.btnAllTarget.classList.remove("is-active")
      } else {
        this.btnAllTarget.classList.add("is-active")
        this.btnActiveTarget.classList.remove("is-active")
      }
    }

    let hidden = 0
    this.campaignTargets.forEach(card => {
      const status = card.dataset.campaignStatus
      const visible =
        (filter === "active" && (status === "open" || status === "paused")) ||
        (filter === "other" && !(status === "open" || status === "paused"))
      card.style.display = visible ? "" : "none"
      if (!visible) hidden++
    })

    if (this.hasHiddenIndicatorTarget && this.hasHiddenCountTarget) {
      if (hidden > 0 && filter === "active") {
        this.hiddenCountTarget.textContent = hidden
        this.hiddenIndicatorTarget.classList.remove("hidden")
      } else {
        this.hiddenIndicatorTarget.classList.add("hidden")
      }
    }
  }
}
